import { toast } from "react-toastify";
import { supabase } from "../../../context/useSupabaseContext";

export default async function getTextFilesForUser(): Promise<string[]> {
    try {
        const { data: { user } } = await supabase.auth.getUser();

        if (!user) {
            console.error("No authenticated user found");
            return [];
        }        

        const { data, error } = await supabase.storage
            .from("user-data")
            .list(user.id);

        if (error) throw error;

        const allFilesPresent = data.map((file) => file.name);

        return allFilesPresent;
    } catch (error) {
        console.error("Error fetching text files:", error);
        toast.error("Failed to fetch text files");
        return [];
    }
}
